<template>
  <NavigationBarTop />
  <div class="container">
      <h1 class="page-head">What Our Clients Say</h1>
      <p class="tagline">Hear from our happy customers about their experiences and results.</p>

      <div class="testimonials-list">
        
        <div class="testimonial-card" v-for="(testimonial, index) in testimonials" :key="index">
          
         
          <h3 class="headline-quote">"{{ testimonial.headline }}"</h3>
          
          <p class="testimonial-body">{{ testimonial.body }}</p>

          <div class="client-info">

            
            <div class="client-avatar-placeholder">{{ clientInitials(testimonial.name) }}</div>

            <div class="client-details">
              <p class="client-name">{{ testimonial.name }}</p>
              <p class="client-date">{{ formatDate(testimonial.created_at) }}</p>
            </div>
          </div>
        </div>
        
      </div>
      
      <section class="submission-section">
          <h3>Share Your Experience</h3>
          <form @submit.prevent="submitTestimonial" class="testimonial-form">
              <div class="form-group">
                  <label for="clientName">Your Name:</label>
                  <input type="text" id="clientName" v-model="newTestimonial.name" required>
              </div>
              <div class="form-group">
                  <label for="clientHeadline">Headline:</label>
                  <input type="text" id="clientHeadline" v-model="newTestimonial.headline" required>
              </div>
              <div class="form-group">
                  <label for="clientBody">Your Story:</label>
                  <textarea id="clientBody" v-model="newTestimonial.body" rows="5" required></textarea>
              </div>
              <button type="submit" class="submit-button">Submit Testimonial</button>
          </form>
      </section>

    </div>
</template>

<script>
import axios from 'axios'
import NavigationBarTop from '@/components/NavigationBarTop.vue'

const API_BASE = `${process.env.VUE_APP_API_URL}/testimonial`
export default {
    components: {
        NavigationBarTop
    },
    async created(){
        this.loadTestimonials()
        
    },
    computed: {
        
    },
    data() {
        return {
            /*testimonials: [
                {
                    rating: 5,
                    headline: "Best color and cut I've had in years!",
                    body: "The team was professional, and my stylist truly listened to what I wanted. I left feeling completely refreshed and confident. Highly recommend Chic Curls Salon!",
                    name: "Sarah M.",
                    detail: "Regular Client Since 2023",
                    image: 'https://via.placeholder.com/60/FF7F50/FFFFFF?text=SM' // Placeholder image
                },
                {
                    rating: 4,
                    headline: "Incredible service and relaxing atmosphere.",
                    body: "I was nervous about a new style, but the consultation was thorough. The results speak for themselves—perfect blow-out and conditioning treatment. I'll be back!",
                    name: "David T.",
                    detail: "First-Time Customer",
                    image: 'https://via.placeholder.com/60/008080/FFFFFF?text=DT' // Placeholder image
                },
                
                {
                    rating: 5,
                    headline: "Best color and cut I've had in years!",
                    body: "The team was professional, and my stylist truly listened to what I wanted. I left feeling completely refreshed and confident. Highly recommend Chic Curls Salon!",
                    name: "Sarah M.",
                    detail: "Regular Client Since 2023",
                    image: 'https://via.placeholder.com/60/FF7F50/FFFFFF?text=SM'
                },
                {
                    rating: 4,
                    headline: "Incredible service and relaxing atmosphere.",
                    body: "I was nervous about a new style, but the consultation was thorough. The results speak for themselves—perfect blow-out and conditioning treatment. I'll be back!",
                    name: "David T.",
                    detail: "First-Time Customer",
                    image: 'https://via.placeholder.com/60/008080/FFFFFF?text=DT'
                },
                {
                    rating: 5,
                    headline: "Truly talented stylists!",
                    body: "I came in with damaged hair and walked out feeling like a new person. The deep conditioning treatment was a miracle worker. Five stars all around for the staff's attention to detail.",
                    name: "Emily R.",
                    detail: "Walk-in Client",
                    image: 'https://via.placeholder.com/60/DAA520/FFFFFF?text=ER'
                }
            ],*/
            testimonials: [],
            // Data for the input form
            newTestimonial: {
                name: '',
                headline: '',
                body: ''
            }
        }
    },
    methods: {
        async loadTestimonials() {
            try {
            const response = await axios.get(`${API_BASE}/get-all`);
            this.testimonials = response.data;
        } catch (error) {
            console.error("Error loading testimonials:", error);
        }
        },
        async submitTestimonial() {
            console.log("New Testimonial Submitted:", this.newTestimonial);
            
            
            // this.newTestimonial = { name: '', headline: '', body: '' };
            try{
                const response = await axios.post(`${API_BASE}/save-testimonial`, this.newTestimonial);
            
            if (response.status === 200 || response.status === 201) {
                alert("Thank you for your feedback!");
                
                await this.loadTestimonials();
                
                
                // Clear the form
                this.newTestimonial = { name: '', headline: '', body: '' };
            }}
            catch(error){
                console.log("Error Saving testimonials,", error)
            }
        },
        formatDate(dateString) {
            if (!dateString) return '';
            const options = { year: 'numeric', month: 'short', day: 'numeric' };
            return new Date(dateString).toLocaleDateString(undefined, options);
        },
        clientInitials(clientName) {
            if (clientName) {
                return clientName.charAt(0).toUpperCase();
            }
            return 'A'; // Default initial
        }
    }
    
}
</script>

<style scoped>
.container {
    max-width: 900px; /* Constraining the max width slightly for better readability */
    margin: 0 auto;
    padding: 0 1rem;
}

.page-head {
    font-size: 2.5rem;
    color: #1c1917;
    margin-top: 2rem;
    text-align: center;
}

.tagline {
    text-align: center;
    color: #666;
    margin-bottom: 3rem;
    font-size: 1.1rem;
}

/*  Testimonials List*/
.testimonials-list {
    /* No grid, allowing default block flow for vertical scrolling */
    padding-bottom: 3rem;
}

.testimonial-card {
    background: #ffffff;
    border: 1px solid #ddd;
    border-radius: 12px;
    padding: 25px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    margin-bottom: 25px; /* Spacing between full-width cards */
    width: 100%; /* Spans the width of its container */
}
.rating {
    color: gold;
    font-size: 1.5rem;
    margin-bottom: 10px;
}

.headline-quote {
    font-size: 1.4rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 15px;
    font-style: italic;
}

.testimonial-body {
    font-size: 1rem;
    color: #555;
    line-height: 1.6;
    margin-bottom: 20px;
}

.client-info {
    display: flex;
    align-items: center;
    padding-top: 15px;
    border-top: 1px dashed #eee;
}

.client-avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 15px;
    border: 2px solid crimson;
}

.client-avatar-placeholder {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    background-color: var(--color-earth); 
    border: 3px solid var(--color-gold); 
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 3rem;
    color: white;
    font-weight: bold;
    flex-shrink: 0;
}

.client-name {
    font-weight: bold;
    color: crimson;
    margin: 0;
}

.client-date {
    font-size: 0.85rem;
    color: #888;
    margin: 2px 0 0 0;
    font-weight: 400;
}

.client-title {
    font-size: 0.9rem;
    color: #888;
    margin: 0;
}

/* Submission Form Styles*/
.submission-section {
    background: #f8f8f8;
    padding: 30px;
    border-radius: 12px;
    border: 1px solid #eee;
    margin-bottom: 3rem;
}

.submission-section h3 {
    color: #333;
    font-size: 1.8rem;
    border-bottom: 2px solid crimson;
    padding-bottom: 10px;
    margin-bottom: 25px;
}

.testimonial-form {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.form-group {
    display: flex;
    flex-direction: column;
}

.form-group label {
    font-weight: 600;
    color: #555;
    margin-bottom: 5px;
}

.form-group input[type="text"],
.form-group textarea {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 1rem;
    width: 100%;
    box-sizing: border-box;
}

.form-group textarea {
    resize: vertical;
}

.submit-button {
    background-color: crimson;
    color: white;
    padding: 12px 20px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 1.1rem;
    font-weight: bold;
    transition: background-color 0.3s;
}

.submit-button:hover {
    background-color: #c0003c; /* Darker crimson */
}
</style>